import { ENVIRONMENT_PREFERRED } from '../constants';
import { TCheckoutEnvironment, TLoadComgateCheckoutConfig, TPreloadComgateCheckoutConfig } from '../types';

export const resolveEnvironment = (config: TLoadComgateCheckoutConfig | TPreloadComgateCheckoutConfig): TCheckoutEnvironment => {
    return ('environment' in config ? config.environment : ENVIRONMENT_PREFERRED) || ENVIRONMENT_PREFERRED;
};
